var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-uploader',{attrs:{"multiple":"","title":_vm.title,"keep-uploaded":false,"concurrency":2,"accept":"image/*"},on:{"queue":function (files) { return _vm.$emit('checkNewPhotos', files); },"uploaded":_vm.onUploaded}})}
var staticRenderFns = []

export { render, staticRenderFns }